export default __webpack_public_path__ + "static/media/screen1.e534e65e.png";